var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1.5)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.245 13.281l2.993-3.89 3.414 2.682 2.93-3.78"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.995,
    cy: 2.7,
    r: 1.922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.924 1.62H5.657C2.645 1.62.778 3.753.778 6.764v8.083c0 3.011 1.83 5.135 4.879 5.135h8.604c3.011 0 4.879-2.124 4.879-5.135v-7.04"
  }))));
};
export default SvgActivity;